import React, { useState, useEffect, useCallback , useRef,memo } from "react";
import useStyles from "./style";
import {  useTheme } from '@mui/material/styles';
import {
  Slide,
  Grid
} from "@mui/material";
import _ from "lodash";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import {
APIProvider, 
Map , 
useMap , 
useMapsLibrary , 
AdvancedMarker , 
Pin , 
InfoWindow 
} from '@vis.gl/react-google-maps';

// Components 

import Dispatcherhead from "./Dispatcherheader";
import DriverList from "./Driverslist"
import BookingForm from "./Bookingform"

//Services
import DispatcherApi from "Services/Dispatcher";
import { API_ENDPOINTS } from "../../Constants";
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
dayjs.extend(customParseFormat);
dayjs.extend(utc);

const Dispatcherpanel = () => {
   
  const timezone = useSelector((state) => {
    const selectedTimezone = state?.timezone?.timezone || 'America/Anchorage';
    return selectedTimezone === "Asia/Coimbatore" ? "Asia/Kolkata" : selectedTimezone;
  });
  const systemlatitude = useSelector((state) => Number(state?.timezone?.latitude) || 11.127123);
  const systemlongitude = useSelector((state) => Number(state?.timezone?.longitude) || 78.656891);
  const classes = useStyles();
  const dispatch = useDispatch();
  const [services, setservices] = useState([]);
  const [allDrivers, setalldrivers] = useState([]);
  const [selectedservice, setSelectedservice] = useState('');
  const [selectedstatus, setSelectedstatus] = useState('ACTIVE');
  const [availabledrivers, setavailabledrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState([]);
  const userType = useSelector(
    (state) => state?.AuthReducer?.userType || ""
  );
  const subcmpnyName = useSelector(
      (state) => state?.AuthReducer?.subCmpny || ""
    );
  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );
  const userid = useSelector(
    (state) => state?.AuthReducer?.userId || ""
  );
  const [open, setOpen] = useState(true);
  const [openbooking, setOpenbooking] = useState(true);
  const [infoWindowData, setInfoWindowData] = useState(null);
  
  //map things 
  const [origin, setOrigin] = useState("");
  const [destination, setDestination] = useState("");
  const [mapCenter, setMapCenter] = useState({ lat: systemlatitude , lng: systemlongitude });
  const map = useMap();
  const mapRef = useRef(null);
  const navigate = useNavigate();
  
  //console.log('mapCenter--->',mapCenter);

  const getservicesanddrivers = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      //console.log("fetched user request data--->",res?.data);
      if (res?.data?.status === true) {
        //console.log("fetched active service data--->",res?.data?.data?.serviceTypeDetails)
        // console.log("fetched available drivers data--->",res?.data?.data?.driverInfoDetails)
        setservices(res?.data?.data?.serviceTypeDetails);
        setalldrivers(res?.data?.data?.driverInfoDetails);
      } else {
        setalldrivers([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get member / partner details Api", err);
    };
    const params = {};
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    DispatcherApi.getdriversandservices(params).then(onSuccess, onFailure);
  }, [demoaccount_id]);
// console.log(allDrivers);
  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.panTo({ lat: systemlatitude, lng: systemlongitude });
    } else {
      setMapCenter({ lat: systemlatitude, lng: systemlongitude });
    }
    getservicesanddrivers();

  }, [systemlatitude, systemlongitude]);  

  // Set selected services from header

  useEffect(() => {
    if (selectedservice) {
      //console.log('Updated Selected Service ID:', selectedservice); 
      getselectedservicedrivers(selectedservice); // Trigger function when selectedservice changes
    }
  }, [selectedservice]);


  const getselectedservicedrivers = useCallback((selectedservice) => {
    dispatch(showLoader("Loading please wait..."));

    //console.log('id--->',selectedservice);
    const onSuccess = (res) => {
      dispatch(hideLoader());
      //console.log("fetched user request data--->",res?.data);
      if (res?.data?.status === true && res?.data?.data?.length > 0) {
        setavailabledrivers(res?.data?.data);
      } else {
        setavailabledrivers([{ no_drivers: "No drivers found for this service" }]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get member / partner details Api", err);
    };
    const params = { id: selectedservice };
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    DispatcherApi.getselectedservicedrivers(params).then(onSuccess, onFailure);
  }, [demoaccount_id]);
  

  // set selected ride status from header

  const getselectedridestatus = useCallback(() => {
    dispatch(showLoader("Loading please wait...")); 
   // //console.log('status--->',selectedstatus);  // status is a string like 'Completed', 'Canceled' etc.
    let data =  {
      rideStatus:selectedstatus
    }
    const onSuccess = (res) => {
      dispatch(hideLoader());
      //console.log("fetched user request data--->",res?.data);
      if (res?.data?.status === true && res?.data?.data?.length > 0) {
        setavailabledrivers(res?.data?.data);
        setSelectedstatus('')
      } else {
        setavailabledrivers([{ no_drivers: "No drivers found for this status" }]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get member / partner details Api", err);
    };
    DispatcherApi.getselectedridestatus(data).then(onSuccess, onFailure);
  }, [selectedstatus]);
  
  useEffect(() => {
    if (selectedstatus) {
      getselectedridestatus(); // Trigger function when selectedservice changes
    }
  }, [selectedstatus]);

  // click the marker to show the driver details

  const handleMarkerClick = useCallback((row) => {
    setInfoWindowData(row);
  }, []);

const libraries = ["places", "drawing" , 'routes'];

// Direction rendering component 

const Directions = memo(({ origin, destination }) => {
const map = useMap();
const routesLibrary = useMapsLibrary("routes");
const [directionsRenderer, setDirectionsRenderer] = useState(null);

useEffect(() => {
if (!origin || !destination) return;

if (!directionsRenderer) {
  const newDirectionsRenderer = new routesLibrary.DirectionsRenderer({ map });
  setDirectionsRenderer(newDirectionsRenderer);
}

const directionsService = new routesLibrary.DirectionsService();

directionsService.route({
    origin,
    destination,
    travelMode: "DRIVING",
  })
  .then((response) => {
    directionsRenderer?.setDirections(response);
  })
  .catch((error) => console.error("Error fetching directions:", error));

return () => {
  directionsRenderer?.setMap(null);
};
}, [origin, destination, map, routesLibrary, directionsRenderer]);

return null;
});

 const driversToShow = selectedDriver && Object.keys(selectedDriver).length > 0 
  ? [selectedDriver] 
  : allDrivers;

  return (
    <>

<Grid container className={classes.mapcontainer} >
<Grid item xs={12} >

<APIProvider 
apiKey={API_ENDPOINTS.GMAP_API} // Use your actual API key
libraries={libraries}
>
<React.Fragment >
<Map
ref={mapRef}
style={{
  width: "111vw",
  height: "111vh",
}}
defaultCenter={mapCenter}
defaultZoom={7}
gestureHandling={"greedy"}
mapId={"40e581fce79a8421a2f62ee2"}
onLoad={(map) => (mapRef.current = map)}
>
{/* Header of the dispatcher panel */}

<Dispatcherhead 
userType={userType}
setSelectedstatus={setSelectedstatus} 
setSelectedservice={setSelectedservice} 
selectedservice={selectedservice}/>

{/* left side driver listing */}

<DriverList 
userType={userType}
subcmpnyName={subcmpnyName}
allDrivers={allDrivers}
availabledrivers={availabledrivers} 
setMapCenter={setMapCenter}
setSelectedDriver={setSelectedDriver}
selectedstatus={selectedstatus}
/>

{/* booking form */}

 <BookingForm
 userType={userType}
 subcmpnyName={subcmpnyName}
 demoaccount_id={demoaccount_id}
 setOpenbooking={setOpenbooking}
 setOpen={setOpen}
 openbooking={openbooking}
 setOrigin={setOrigin}
 setDestination={setDestination}
 origin={origin} destination={destination}
 setMapCenter={setMapCenter}
 services={services}
 timezone={timezone}
 />

{/* direction rendering */}

<Directions origin={origin} destination={destination} />

{/* Customized Car Marker */}

{driversToShow.map((driver) => (
<AdvancedMarker 
position={{ 
lat:Number(driver?.driver_ride_details?.latitude), 
lng:Number(driver?.driver_ride_details?.longitude) }}    
title="Driver Location"
onClick={() => handleMarkerClick(driver)}>
<Pin
background= {
  driver?.driver_ride_details?.rideStatus == 'ACTIVE' ? '#30e356': 
  driver?.driver_ride_details?.rideStatus == 'OFFLINE'? '#f44336':'#0472e2'}
borderColor={
  driver?.driver_ride_details?.rideStatus == 'ACTIVE' ? '#30e356': 
  driver?.driver_ride_details?.rideStatus == 'OFFLINE'? '#f44336':'#0472e2'
}
glyphColor={'#fffff'}
>
<img 
  src={
    driver?.driver_ride_details?.rideStatus == 'ACTIVE' ? 
    '/assets/images/DispatcherIcons/activecar.png' : 
    driver?.driver_ride_details?.rideStatus == 'OFFLINE' ? 
    '/assets/images/DispatcherIcons/offlinecar.png' : 
    '/assets/images/DispatcherIcons/activecar.png'
  }
  alt="Driver Car"
  style={{ 
    width: "40px", 
    height: "40px",
    borderRadius: "12px"
  }} 
/>
</Pin>
</AdvancedMarker>
))}

{infoWindowData && (
<InfoWindow
position={{ 
lat:Number(infoWindowData?.driver_ride_details?.latitude), 
lng:Number(infoWindowData?.driver_ride_details?.longitude)
}}
onCloseClick={() => setInfoWindowData(null)}
>
<div style={{ padding: '10px' }}>
<h3>Driver Details</h3>
<p><b>Name:</b> {infoWindowData?.firstName+" "+infoWindowData?.lastName}</p>
<p><b>Car:</b> {infoWindowData?.driver_ride_details?.service_details?.serviceName}</p>
<p><b>Address:</b> {infoWindowData?.driver_ride_details?.address}</p>
</div>
</InfoWindow>
)}

</Map>
</React.Fragment>
</APIProvider>

</Grid>
</Grid>
    </>
  );
};



export default Dispatcherpanel;
